var indexOf = [].indexOf;

import {
  colorPickerColors
} from 'constants/colors';

angular.module('gym.pos').controller('ManageProductCategoryModalCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "$timeout", "ProductCategories", function($scope, $rootScope, $modalInstance, $http, $timeout, ProductCategories) {
  var clearErrors, getIncomeCategories, gym, reload;
  gym = $rootScope.gym;
  $scope.colors = colorPickerColors;
  $scope.newCategory = {};
  getIncomeCategories = function() {
    var params, url;
    url = `/gyms/${gym.id}/accounting_codes`;
    params = {
      count: 1000,
      'filters[category]': 'for_pos_product'
    };
    return $http.get(url, {
      params: params
    }).then(function(response) {
      return $scope.incomeCategories = response.data.collection;
    });
  };
  getIncomeCategories();
  $scope.getIncomeCategoryLabel = function(category) {
    return `Income category: ${category.name} [${category.code}]`;
  };
  reload = function() {
    return ProductCategories.getList({
      count: 1000
    }).then(function(categories) {
      return $scope.categories = categories;
    });
  };
  reload();
  clearErrors = function(category) {
    $scope.error = void 0;
    $scope.newCategory.errors = void 0;
    if (category) {
      return category.errors = void 0;
    }
  };
  $scope.ok = function() {
    return $modalInstance.close();
  };
  $scope.save = function(category) {
    clearErrors(category);
    return category.save().then(function() {
      return reload();
    }, function(response) {
      return category.errors = response.data.errors;
    });
  };
  $scope.edit = function(category) {
    clearErrors(category);
    category._edit = true;
    if ($scope.isCustomColorSelected(category)) {
      return category.customColor = category.color;
    }
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  $scope.create = function() {
    clearErrors();
    return ProductCategories.post($scope.newCategory).then(function(category) {
      $scope.newCategory = {};
      return $scope.categories.push(category);
    }, function(response) {
      return $scope.newCategory.errors = response.data.errors;
    });
  };
  $scope.isCustomColorSelected = function(category) {
    var ref;
    return category.color && (ref = category.color, indexOf.call($scope.colors, ref) < 0);
  };
  $scope.setColor = function(category, color) {
    category.color = category.color === color ? null : color;
    return category.customColor = void 0;
  };
  $scope.$on('colorpicker-closed', function(currentScope, color) {
    return $timeout(function() {
      var category;
      category = _.find($scope.categories, function(item) {
        return item._edit;
      });
      if (category) {
        return category.color = color.value || null;
      }
    });
  });
  return $scope.delete = function(category) {
    if (window.confirm("Are you sure?")) {
      clearErrors(category);
      return category.remove().then(function() {
        return reload();
      }, function(response) {
        return $scope.error = 'This category is in use and cannot be deleted at this time.';
      });
    }
  };
}]);
